import { BaseFrameworkError } from "@bloglovin/vue-framework";

class DynamicComponentError extends BaseFrameworkError {}

export default DynamicComponentError;
